export default __webpack_public_path__ + "static/ab-devices-mobile-891c6248caf01f4ab8eaef4f86c9dc8d.jpg";